export const vehicleTypes = ['RENTED', 'YELLOW', 'CARGO', 'LIGHT', 'TRAILER'];

export const vehicleTypeFilterOptions = [
    { value: 'RENTED', text: 'Alquilado' },
    { value: 'YELLOW', text: 'Amarillo' },
    { value: 'CARGO', text: 'Cabezal' },
    { value: 'LIGHT', text: 'Liviano' },
    { value: 'TRAILER', text: 'Remolque' },
];
